<script setup>
const props = defineProps({
  room: Object,
  setCursor: Function,
});

const localePath = useLocalePath();
const { locale } = useI18n();

const priceQuery = gql`
		query GetPrice($name: String!) {
			pages(where: {language: ${locale.value
        .toString()
        .toUpperCase()}, name: $name}) {
				edges {
					node {
						id
						title
						spacesconfig {
							price
						}

					}
				}
			}
		}
	`;

const { data } = await useAsyncQuery(priceQuery, { name: props.room.key });
const price = data?.value.pages?.edges[0].node.spacesconfig.price;

const cursorAction = () => {
  return navigateTo(
    localePath({ name: "space-id", params: { id: props.room.key } })
  );
};
</script>

<template>
  <div
    class="meeting-room-container flex flex-col justify-between"
    @mouseenter="
      setCursor($t('more-info'), cursorAction, {
        'font-size': '14px',
        width: '100px',
        height: '100px',
      })
    "
    @mouseleave="
      setCursor(null, null, {
        'font-size': '14px',
        width: '25px',
        height: '25px',
      })
    "
  >
    <div>
      <div class="meeting-room-image">
        <img :src="room.imgSrc" />
      </div>
      <div class="px-4">
        <h2 class="py-4">{{ $t(room.name) }}</h2>
        <p class="pb-4">{{ $t(room.description) }}</p>
      </div>
    </div>

    <div class="px-4 flex justify-between items-end">
      <div>
        <div class="font-light !text-xl">
          {{ room.space }} m² / {{ room.capacity }}
          {{ $t("spaces.meetingrooms.persons") }}
        </div>
        <div class="txt-t font-bold !text-xl">
          <span v-if="$i18n.locale === 'en'" class="font-medium">CZK </span
          >{{
            new Intl.NumberFormat(
              $i18n.locale === "cs" ? "cs-CZ" : "en-GB"
            ).format(price)
          }}
          <span v-if="$i18n.locale === 'cs'" class="font-medium">Kč </span>/
          {{ $t("spaces.meetingrooms.hour") }}
        </div>
      </div>
      <div class="xl:hidden">
        <button
          class="pointer-events-auto whitespace-nowrap bg-transparent border rounded-full border-black px-4 py-2 text-sm"
          @click="cursorAction"
        >
          {{ $t("spaces.meetingrooms.moreInfo") }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.meeting-room-container {
  width: 380px;

  h2 {
    font-size: 28px !important;
    font-weight: 500;
  }
  p {
    font-size: 16px;
    font-weight: 300;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    margin-bottom: 35px;
    padding: 1.5rem;

    img {
      width: 100%;
      height: auto;
      max-height: 350px;
      object-fit: cover;
    }
  }
  @media screen and (max-width: 1248px) {
    width: 100%;
    //margin-bottom: 35px;
    padding: 1.5rem;

    img {
      width: 100%;
      height: auto;
      max-height: 350px;
      object-fit: cover;
    }
  }
}
.meeting-room-image {
  position: relative;
  padding-top: 65%;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}
</style>
